class TsUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
  }

  async rerenderUpsell() {
    const cartResponse = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
    const cartData = await cartResponse.json();

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = cartData['cart-drawer'];

    const newUpsell = tempDiv.querySelector('[data-upsell]');
    const oldUpsell = document.querySelector('[data-upsell]');

    if (newUpsell && oldUpsell) {
      oldUpsell.innerHTML = newUpsell.innerHTML;
    } else if (!newUpsell) {
      this.remove();
    }

    theme.addedToCartHandler();
  }

  disconnectedCallback() {
  }
}

customElements.define('ts-upsell', TsUpsell);
